/**
 * Settings that are used in multiple places, right now just API URLs
 */

// creates a contact in LoanForce - use custom setting if set, if not fall back to OTHL endpoint
// some devices & browsers won't work with the OTHL endpoint because CORS so the idea is to host the script on the site's own server
const CONTACT_CREATION_ENDPOINT = window.sanctum.contact_creation_endpoint
  ? window.sanctum.contact_creation_endpoint
  : 'https://onetrusthomeloans.com/misc/create_lf_contact.php';

// used to get list of states to populate select element in Schedule a Consultation form
const GRAPHQL_API_URL = 'https://graphql-onetrust.herokuapp.com/';

export { CONTACT_CREATION_ENDPOINT, GRAPHQL_API_URL };



// WEBPACK FOOTER //
// ./scripts/util/config.js